import {qspost} from '@/plugins/axios'

/*
 * 员工数据屏
 * @constructor jack
 * */
export const YGtongJiOne = (adminId, year,month) => qspost('/Index/Datascreen/YGtongJiOne', {adminId, year,month})
export const YGtongJiTwo = (adminId, year,month) => qspost('/Index/Datascreen/YGtongJiTwo', {adminId, year,month})

/*
 * 小区数据屏
 * @constructor jack
 * */
export const XQtongJiOne = (xiaoQuId, year,month) => qspost('/Index/Datascreen/XQtongJiOne', {xiaoQuId, year,month})
export const XQtongJiTwo = (xiaoQuId, year,month) => qspost('/Index/Datascreen/XQtongJiTwo', {xiaoQuId, year,month})


/*
 * 员工数据屏
 * @constructor jack
 * */
export const XMtongJiOne = (xiangMuId, year,month) => qspost('/Index/Datascreen/XMtongJiOne', {xiangMuId, year,month})
export const XMtongJiTwo = (xiangMuId, year,month) => qspost('/Index/Datascreen/XMtongJiTwo', {xiangMuId, year,month})



/*
 * 获取所有小区
 * @constructor jack
 * */
export const getAllXiaoQu = (xiangmu_id) => qspost('/Index/Save/getAllXiaoQu', {xiangmu_id})

/*
 * 获取项目下的小区
 * @constructor jack
 * */
export const getXiaoQuList = () => qspost('/Index/Save/getAllXiaoQu', {})

/*
 * 处理报警
 * @constructor jack
 * */
export const setSaveState = (id) => qspost('/Index/Save/setSaveState', {id})

/*
 * 项目统计屏
 * @constructor jack
 * */
export const dataScreenTotal = (xiaoqu_id,xiangmu_id) => qspost('/Index/Save/dataScreenTotal', {xiaoqu_id,xiangmu_id})

/*
 * 项目统计屏
 * @constructor jack
 * */
export const getSaveList = (xiaoqu_id,type,page,pageSize,xiangmu_id = '') => qspost('/Index/Save/getSaveList', {xiaoqu_id,type,page,pageSize,xiangmu_id})

/*
 * 项目统计屏
 * @constructor jack
 * */
export const dataScreenShenQu = (xiaoqu_id,name,phone,IMEI) => qspost('/Index/Save/dataScreenTotal', {xiaoqu_id,name,phone,IMEI})

/*
 * 项目统计屏
 * @constructor jack
 * */
export const getSaveListScreenShenQu = (xiaoqu_id,name,phone,IMEI,page,pageSize) => qspost('/Index/Save/dataScreenShenQu', {xiaoqu_id,name,phone,IMEI,page,pageSize})
/*
 * 项目统计屏
 * @constructor jack
 * */
export const getXiangMuMap = (xiangmu_id) => qspost('/Index/Save/getXiangMuMap', {xiangmu_id})

/*
 * 项目统计屏
 * @constructor jack
 * */
export const dataScreenXiaoQin = (xiangmu_id) => qspost('/Index/Save/dataScreenXiaoQin', {xiangmu_id})

/*
 * 项目统计屏
 * @constructor jack
 * */
export const dataScreenUserArr = () => qspost('/Index/Save/dataScreenUserArr', {})

/*
 * 项目统计屏
 * @constructor jack
 * */
export const dataScreenOneUser = (jumin_id) => qspost('/Index/Save/dataScreenOneUser', {jumin_id})

/*
 * 项目统计屏
 * @constructor jack
 * */
export const dataScreenDeviceTotal = (xiangmu_id) => qspost('/Index/Device/dataScreenTotal', {xiangmu_id})

/*
 * 项目统计屏
 * @constructor jack
 * */
export const getSaveDeviceList = (xiaoqu_id,type,page,pageSize,xiangmu_id = '') => qspost('/Index/Device/getSaveList', {xiaoqu_id,type,page,pageSize,xiangmu_id})

/*
 * 项目统计屏
 * @constructor jack
 * */
export const setSaveDeviceState = (id,images) => qspost('/Index/Device/setSaveState', {id,images})

/*
 * 项目统计屏
 * @constructor jack
 * */
export const getSaveDetailsById = (id,token) => qspost('/Index/Device/getSaveDetailsById', {id,token})

/*
 * 项目统计屏
 * @constructor jack
 * */
export const getSaveListByToken = (token) => qspost('/Index/Device/getSaveListByToken', {token})


/*
 * 亲情统计屏
 * @constructor jack
 * */
export const dataScreenLoveTotal = (xiangmu_id) => qspost('/Index/love/dataScreenTotal', {xiangmu_id})

/*
 * 亲情图片
 * @constructor jack
 * */
export const qqBannerList = () => qspost('/Index/love/qqBannerList', {})

/*
 * 亲情图片
 * @constructor jack
 * */
export const delLoveBanner = (id) => qspost('/Index/love/delBanner', {id})

/*
 * 亲情图片
 * @constructor jack
 * */
export const getLoveBanner = (id) => qspost('/Index/love/bannerDetail', {id})

/*
 * 亲情图片
 * @constructor jack
 * */
export const saveLoveBanner = (id,name,image) => qspost('/Index/love/saveBanner', {id,name,image})
